import React from "react"
import pdfMakeTbl from './pdfMakeTbl'
import LoadProducts from "../components/loadProducts"

export async function exportList(products) {
  await pdfMakeTbl(products);
}


import _ from 'lodash';

export class csvLines{

  products = [];

  constructor(products) {
      this.products = products;
  }

  getGroupedBadgesForManyProducts(x) {
      let resultAllProducts= _.map(x, (z) => _.groupBy(z, (y) => y["area"] ))
      return resultAllProducts

  }

  getValidations() {
      let rawValidations= [...this.products.map(_ => _.validations)]
      return rawValidations
  }

  // HIGH LEVEL csvLineOfValidationsByArea for interoperability, privacy, ...
  hiLevelCsvLineOfValidationsByArea(area){
      function convertToRawMereBadges(listOfProductsWithSimplifiedBadges1, area){
        const stageOne=  _.map( listOfProductsWithSimplifiedBadges1, (OneProduct) => {
            return _.groupBy(_.map (OneProduct, (OneValidationEntry) => {
                return [OneValidationEntry.area, OneValidationEntry.label]
            }),  (entry)=> (entry[0]))

        } )   

       const stageTwoB = _.map(stageOne, (EachProduct) => {
           return _.map(EachProduct, (EntryList, EachArea,coll)=>{
             let x={}  
             x[EachArea ]=_.map(EntryList, (EachEntry)=>{
                 const label=1
                 return EachEntry[label]
             })
             return x  
           })
       })
       const stageTwoC = _.map(stageTwoB, (EachProduct) => {

        return EachProduct.reduce((a, b) => Object.assign(a,b), {})
       })

       const selectArea = _.map(stageTwoC, (EachProduct) =>{
           return (EachProduct[area]?.join(', '))??''
       })
       
       return selectArea 
      }

      // mapping field name to description for CSV
      function mappedAreaDesc(a){
        const descMap={
          'Interoperability':'Interoperability Badges & Certifications',
          'Privacy':'Privacy Badges',
        }

        if (!!(descMap[a]))
           return descMap[a]

        return a
      }
      
      const products=this.products
      let xcm=  new csvLines(products)

      const productsOnlyWithValidations = xcm.getValidations();

      let contentWithMultipleBadges= convertToRawMereBadges(productsOnlyWithValidations,area)

      const mappedArea= mappedAreaDesc(area)
      return [[mappedArea].concat(...contentWithMultipleBadges)]
  }

  undefToValueHashArr = _ => (_ == undefined) ? [{ 'value': '' }] : _; // avoid breaking if value's undefined

  productHeaderNamesOnly = this.products.map(_ => (_.name));
  
  productName = () => [['', ...this.products.map(_ => (_.name))]];
  productHeader = () => [[...this.productHeaderNamesOnly]];

  productLink = () => [['Product Website', ...this.products.map(_ => (_.mainEntityOfPage))]];
  productDesc = () => [['Product Description', ...this.products.map(_ => (_.publicDescription))]];
  
  ultidOnCsv = () => [['ULTID', ...this.products.map(_ => (_.ultid))]];

  learningAudience = () => [['Audiences', ...this.products.map(_ => ((this.undefToValueHashArr(_.learningAudience).map(_ => (_.value)).join(', '))))]];

  educationalLevel = () => [['Education Level', ...this.products.map(_ => ((this.undefToValueHashArr(_.educationalLevel).map(_ => (_.value)).join(', '))))]];
  intendedProductUser = () => [['Primary Users', ...this.products.map(_ => ((this.undefToValueHashArr(_.intendedProductUser).map(_ => (_.value)).join(', '))))]];
  productCategories = () => [['Product Categories', ...this.products.map(_ => ((this.undefToValueHashArr(_.learningTechnologyCategory).map(_ => (_.value)).join(', '))))]];
  academicDiscipline = () => [['Discipline', ...this.products.map(_ => ((this.undefToValueHashArr(_.academicDiscipline).map(_ => (_.value)).join(', '))))]];
  academicSubjectArea = () => [['Subjects Area', ...this.products.map(_ => ((this.undefToValueHashArr(_.academicSubjectArea).map(_ => (_.value)).join(', '))))]];
  contentAttributes = () => [['Content Attributes', ...this.products.map(_ => ((this.undefToValueHashArr(_.contentAttributes).map(_ => (_.value)).join(', '))))]];
  academicContentStandards = () => [['Content Standards', ...this.products.map(_ => ((this.undefToValueHashArr(_.academicContentStandards).map(_ => (_.value)).join(', '))))]];

  learnerProgressTracking = () => [['Learner Progress Features', ...this.products.map(_ => ((this.undefToValueHashArr(_.learnerProgressTracking).map(_ => (_.value)).join(', '))))]];
  instructionalFeedback = () => [['Feedback', ...this.products.map(_ => ((this.undefToValueHashArr(_.instructionalFeedback).map(_ => (_.value)).join(', '))))]];
  communicationFeatures = () => [['Communication', ...this.products.map(_ => ((this.undefToValueHashArr(_.communicationFeatures).map(_ => (_.value)).join(', '))))]];

  teachingAndLearningApproaches = () => [['Approaches', ...this.products.map(_ => ((this.undefToValueHashArr(_.teachingAndLearningApproaches).map(_ => (_.value)).join(', '))))]];
  pricingDescription = () => [['Pricing Description', ...this.products.map(_ => ((this.undefToValueHashArr(_.pricingDescription))))]];

  planType = () => [['Pricing Model', ...this.products.map(_ => ((this.undefToValueHashArr(_.planType).map(_ => (_.value)).join(', '))))]];
  productTraining = () => [['Product Training', ...this.products.map(_ => ((this.undefToValueHashArr(_.productTraining).map(_ => (_.value)).join(', '))))]];
  productTrainingCostDescription = () => [['Training Price Description', ...this.products.map(_ => (_.productTrainingCostDescription))]];  
  mobileOptimizedStr = () => [['Optimized for Mobile', ...this.products.map(_ => (_.mobileOptimized == 1) ? 'Yes' : ((_.mobileOptimized == 0) ? 'No' : 'N/A'))]];
  supportedOperatingSystems = () => [['Supported Operating Systems', ...this.products.map(_ => ((this.undefToValueHashArr(_.supportedOperatingSystems).map(_ => (_.value)).join(', '))))]];
  softwareRequirements = () =>  [['Requirements', ...this.products.map(_ => (_.softwareRequirements))]];


  // New fields 202200704  
  activeIntegrationPartnershipsUrl = () => [['Active Integrations', ...this.products.map(_ => (_.activeIntegrationPartnershipsUrl))]];
  
  compatibleLearningManagementSystems =  () => [['Compatible LMS', ...this.products.map(_ => ((this.undefToValueHashArr(_.compatibleLearningManagementSystems).map(_ => (_.value)).join(', '))))]];
  sisCompatibility = () =>  [['Compatible SIS', ...this.products.map(_ => ((this.undefToValueHashArr(_.sisCompatibility).map(_ => (_.value)).join(', '))))]];
  interoperabilityAuthenticationSSO = () =>  [['Authentication and SSO', ...this.products.map(_ => ((this.undefToValueHashArr(_.interoperabilityAuthenticationSSO).map(_ => (_.value)).join(', '))))]];
  interoperabilityAuthorization = () =>  [['Authorization', ...this.products.map(_ => ((this.undefToValueHashArr(_.interoperabilityAuthorization).map(_ => (_.value)).join(', '))))]];

  interoperabilityCost = () =>   [['Cost Description for Interoperability', ...this.products.map(_ => ((this.undefToValueHashArr(_.interoperabilityCost).map(_ => (_.value)).join(', '))))]];
  costDescription = () => [['Cost DescriptionCost Description for Interoperability', ...this.products.map(_ => (_.costDescription))]];

  spdcNationalDataPrivacyAgreementLabel = () =>  [['SDPC National Data Privacy Agreement label', ...this.products.map(_ => (_.spdcNationalDataPrivacyAgreementLabel))]];
  spdcNationalDataPrivacyAgreementUrl   = () =>  [['SDPC National Data Privacy Agreement url', ...this.products.map(_ => (_.spdcNationalDataPrivacyAgreementUrl))]];

  spdcLabelWithUrl = () => {
    const sLabel = this.spdcNationalDataPrivacyAgreementLabel()[0]
    const sUrl   = this.spdcNationalDataPrivacyAgreementUrl()[0]

    let ans = _.zipWith(sLabel, sUrl, function(ll, uu){
      if ((!ll) && (!uu)) return ""

      const llNoNull = ll??""
      const uuNoNull = uu??""
      
      return `${llNoNull} (${uuNoNull} )`
    })
    ans[0] = "SDPC National Data Privacy Agreement"
    return [ans]

  }

  privacyPoliciesUrls =  () => [['Privacy Policies', ...this.products.map(_ => ((this.undefToValueHashArr(_.policies).map(_ => ( `${_.urlTitle}(${_.url})` )).join(', '))))]];
  privacyStatement = () =>  [['Privacy Statement', ...this.products.map(_ => (_.privacyStatement))]];
  learnerData = () =>  [['Learner Data Collected', ...this.products.map(_ => ((this.undefToValueHashArr(_.learnerData).map(_ => (_.value)).join(', '))))]];
  dataUseDescription = () =>  [['Data Use Description', ...this.products.map(_ => (_.dataUseDescription))]];

  RubricHeader = () => "RUBRIC:\r\nAnswer the questions below by choosing an answer from the drop down menu/data validation. Simply select the cell and click the arrow in the lower right hand corner to see answer options. For open-ended questions, type in your answer."
  FirstRubricItem = () =>'To what degree do you think this tool can help solve your problem of practice, organizational needs and satisfy your non-negotiables?'

  getRubricLines = () => {

    let rubicLabels= [
    this.RubricHeader(),
    this.FirstRubricItem(),
    'Please add any additional comments on how this product addresses your pain point and non-negotiables.',
    "To what degree do you feel that the product is aligned to your team's vision and goals for teaching and learning?",
    'To what degree do you feel that the product is aligned to how students learn best? ',
    'To what degree do you feel that the product is aligned to how the educators teach best?',
    'Please indicate how engaging this product might be for your learners or intended users.',
    'To what degree do you think most educators, students, or other users will find the product easy to adopt and use?',
    '[If applicable] How well do you see the product fitting with your existing curriculum?',
    'What challenges do you see that would make this solution difficult to implement?',
    'To what extent is this solution designed to meet the needs of all students? (e.g. culturally and gender sensitive content, students with special needs, students with learning differences, etc.)',
    'Does this solution appear to meet your data needs? ',
    'Are there questions you need to answer to determine alignment with the privacy, security, and data requirements of the solution?',
    'Review the integration and interoperability needs of your school. Does the product have the interoperability you need?',
    'Review the hardware requirements you have. Is this product compatible?',
    '[Enter your own question]',
    '',
    "Final Thoughts : Use this space to jot down your initial thoughts about this tool's potential impact on your academic environment."
    ];

    return _.map(rubicLabels, (x) => [x].concat(_.times(this.products.length, _.constant(''))))
  }
  csvTable() {
    // NOTE:Ref:  https://docs.google.com/spreadsheets/d/1LG69sANAmAMMgySZQtBK-lV_DleFh9k-PmVkoBjopMA/edit#gid=640390226

    return ([
      ...this.productName(),
      ...this.ultidOnCsv(),
      ...this.productLink(),

      ...this.productDesc(),
      ...this.learningAudience(),
      ...this.educationalLevel(),
      ...this.intendedProductUser(),
      ...this.productCategories(),
      ...this.academicDiscipline(),
      ...this.academicSubjectArea(),
      ...this.contentAttributes(),
      ...this.academicContentStandards(),

      ...this.learnerProgressTracking(),
      ...this.instructionalFeedback(),
      ...this.communicationFeatures(),
      ...this.teachingAndLearningApproaches(),
      ...this.pricingDescription(),

      ...this.planType(),
      ...this.productTraining(),


      // new field 20220704
      ...this.hiLevelCsvLineOfValidationsByArea('Interoperability'),
      ...this.activeIntegrationPartnershipsUrl(),

      
      ...this.compatibleLearningManagementSystems(),
      ...this.sisCompatibility() ,
      ...this.interoperabilityAuthenticationSSO() ,
      ...this.interoperabilityAuthorization() ,

      ...this.interoperabilityCost() ,
      ...this.costDescription() ,

      ...this.hiLevelCsvLineOfValidationsByArea('Privacy'),
      ...this.spdcLabelWithUrl() ,
      ...this.privacyPoliciesUrls(),

      ...this.privacyStatement() ,
      ...this.learnerData() ,
      ...this.dataUseDescription() ,
      
      ...this.mobileOptimizedStr(),
      ...this.supportedOperatingSystems(),
      ...this.softwareRequirements(),

    ]  )
    // .concat(this.getRubricLines())); // Disabled rubric for csv upon user request
  }
}


let forEachProduct = (p) => _.map(p, function(value, key, coll) {
    // value : list of item containing labels
    
    let eachProductSimplfied = {}
    eachProductSimplfied[key] = _.map(value, 'label')

    return eachProductSimplfied
  });

let getValidationListOfStrByArea = (prodsWithSimpleBadges, area) =>
{
    // filter is to remove undefined items
    const oneArea = _.filter( _.map(prodsWithSimpleBadges, (p) => p[area]), (item) => (!!item))
    return oneArea
}
export function exportCSV(products) {
  const data = new csvLines(products)

  var fileDownload = require('js-file-download');
  let csvTableData=data.csvTable()
  fileDownload(toCSV(csvTableData), 'EdTech Index Shortlist Data.csv');

}

export function exportCSV2orXlsx(products) {
  
}


function toCSV(table: string[][]) {
  return table
      .map(row =>
          row
              .map(c => {

                  if (!c) return '""'
                  
                  // We remove blanks and check if the column contains
                  // other whitespace,`,` or `"`.
                  // In that case, we need to quote the column.
                  let cell =c.toString()  // numeric-fields safe
                  try {
                    if (cell.replace(/ /g, '').match(/[\s,"]/)) {
                      return '"' + cell.replace(/"/g, '""') + '"';
                    }
                  }
                  catch (err) {
                    console.error(err);
                  }
                  return cell;
              })
              .join(',')
      )
      .join('\n');
}




export function exportXLSX(products) {
  const data = new csvLines(products)

  var fileDownload = require('js-file-download');
  fileDownload(toXLSX(data.csvTable(),products), 'My Excel.xlsx')
}

function toXLSX(table:string[][],products) : any {
   return exportXLSX(products)
}
